import { PART_STATUS } from '../../constants/PartsConstants';
import { AogPartInputParams } from '../../Models/Orderpart';
import { OtsAircraft } from '../../Models/OtsAircraft';
import { User } from '../../Models/User';

//map Parts user entered data to AogPartInputParams
export function mapPartsCreateRequest(parts: any[], otsAircraft: OtsAircraft, userData: User ) : AogPartInputParams {
    return {
        OtsEventId: otsAircraft?.id,
        Airline: otsAircraft?.Airline,
        AircraftRegistration: `N${otsAircraft?.AircraftRegistration}`,
        CreatedBy: userData.profile.name,
        LastUpdatedBy: "",
        Parts: parts.map((part: any) => ({
          IPC: part.IPC,
          Status: PART_STATUS.REQUESTED,
          PartNumber: part.PartNumber.toString(),
          PartName: part.PartName,
          Quantity: part.Quantity,
          CreatedBy: userData.profile.name,
          LastUpdatedBy: "",
        }))
    }
}